window.addEventListener('DOMContentLoaded', () =>
{
  const button = document.querySelector('.nav__button');
  const nav = document.querySelector('.nav');
  const content = document.querySelector('.nav__content');
  const overlay = document.querySelector('.nav__overlay');
  const close = document.querySelector('.tools__close-menu');
  const header = document.querySelector('.header');

  const showMenu = () =>
  {
    nav.classList.toggle('toggle');
    overlay.classList.toggle('overlay-visible');
    content.classList.toggle('nav__content_open');
    header.classList.add('header_open');
    const html = document.querySelector('#html');
    html.style.overflowY = 'hidden';
  };

  const closeMenu = () =>
  {
    const html = document.querySelector('#html');
    html.style.overflowY = 'scroll';
    nav.classList.remove('toggle');
    overlay.classList.remove('overlay-visible');
    content.classList.remove('nav__content_open');
    button.classList.remove('active');
    header.classList.remove('header_open');
    const scrollY = window.scrollY;
    setTimeout(() => window.scroll({
      top: scrollY, behavior: 'auto',
    }));
  };

  if(document.querySelector('.burger-menu'))
  {
    button.addEventListener('click', () =>
    {

      button.classList.toggle('active');
      button.classList.contains('active') ? showMenu() : closeMenu();
    });

    // close.addEventListener('click', closeMenu);

    document.addEventListener('click', (event) =>
    {
      const el = event.target;

      if(el === overlay)
      {
        closeMenu();
      }
    });
  }
});
